
<div [innerHTML]="dynamicHtml"></div>
<style [innerHTML]="css"></style>